import type {
  BetslipActions,
  BetslipStore,
  SliceCreator,
} from "@/features/betslip/stores/types";
import { exitConfirmingIfMutated } from "@/features/betslip/stores/slices/submission";

export const initialPromoCashState: Pick<BetslipStore, "promoCash"> = {
  promoCash: { singles: {}, multi: false },
};

export const prunePromoCashByOutcomeIds = (
  state: BetslipStore,
  drop: ReadonlySet<string>,
): Pick<BetslipStore, "promoCash"> => {
  const nextSingles: Record<string, boolean> = {};
  for (const [outcomeId, isUsing] of Object.entries(state.promoCash.singles)) {
    if (!drop.has(outcomeId)) nextSingles[outcomeId] = isUsing;
  }
  return { promoCash: { ...state.promoCash, singles: nextSingles } };
};

type PromoCashActions = Pick<
  BetslipActions,
  "toggleSinglePromoCash" | "toggleMultiPromoCash"
>;

export const promoCashSlice: SliceCreator<
  typeof initialPromoCashState & PromoCashActions
> = (set) => ({
  ...initialPromoCashState,

  toggleSinglePromoCash: (outcomeId) => {
    set((state) => {
      // Switching the funding source resets the token pick for this
      // selection so a stale token can't ride along. The multi toggle
      // deliberately doesn't cross-clear the multi token.
      const nextTokenSingles = { ...state.tokens.singles };
      delete nextTokenSingles[outcomeId];

      return {
        ...exitConfirmingIfMutated(state),
        promoCash: {
          ...state.promoCash,
          singles: {
            ...state.promoCash.singles,
            [outcomeId]: !(state.promoCash.singles[outcomeId] ?? false),
          },
        },
        tokens: { ...state.tokens, singles: nextTokenSingles },
      };
    });
  },

  toggleMultiPromoCash: () => {
    set((state) => ({
      ...exitConfirmingIfMutated(state),
      promoCash: { ...state.promoCash, multi: !state.promoCash.multi },
    }));
  },
});
